import { render, staticRenderFns } from "./SingleThermalModuleTestDatalnfo.vue?vue&type=template&id=28aeb548"
import script from "./SingleThermalModuleTestDatalnfo.vue?vue&type=script&lang=js"
export * from "./SingleThermalModuleTestDatalnfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports